import { ReactNode, createContext, useContext } from "react";
import { useFilterUtilService } from "./filter-util-service.hook";

const FilterUtilServiceContext = createContext(
  {} as ReturnType<typeof useFilterUtilService>
);
export function useFilterUtilServiceContext() {
  return useContext(FilterUtilServiceContext);
}

interface FilterUtilServiceProviderProps {
  children: ReactNode;
}
export function FilterUtilServiceProvider({
  children,
}: FilterUtilServiceProviderProps) {
  return (
    <FilterUtilServiceContext.Provider value={useFilterUtilService()}>
      {children}
    </FilterUtilServiceContext.Provider>
  );
}